class CartCount extends HTMLElement {
  constructor() {
    super();

    this.counter = document.getElementById('cart-count');
  }

  updated() {
    // TODO: Animate this.counter
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    // this.updated();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-count',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

customElements.define('cart-count', CartCount);
